import { defineComponent } from 'vue'
import {
  NavBar as VanNavBar,
  Icon as VanIcon,
  Row as VanRow,
  Col as VanCol,
  showToast,
} from 'vant'
import { useSmartBack } from '@/composables/use-smart-back'
import { useSiteConfigStore } from '@/stores/site-config-store'
import { ExternalAnchor } from '@/components/external-anchor'
import kefuTx from '@/assets/contact-service/kefu-tx.png'
import onlineKefu from '@/assets/contact-service/online-kefu.png'

export default defineComponent({
  name: 'ContactCustomerServicePage',
  setup() {
    const goBack = useSmartBack()
    const siteConfigStore = useSiteConfigStore()

    return () => (
      <div class="min-h-screen bg-white">
        <VanNavBar title="联系客服" fixed placeholder onClickLeft={goBack}>
          {{
            left: () => <VanIcon name="arrow-left" color="#333" size="16" />,
          }}
        </VanNavBar>

        {/* 顶部说明区：左侧插图 + 右侧文字（dfomc 8/16 分栏） */}
        <div class="p-[0.26rem] pb-[0.8rem]">
          <VanRow align="center">
            <VanCol span={8}>
              <img src={kefuTx} class="w-full" alt="客服" />
            </VanCol>
            <VanCol span={16}>
              <div class="text-[0.6rem] text-[#000] font-medium pt-[0.4rem] pb-[0.2rem] leading-[0.84rem]">
                有问题请找客服
              </div>
              <div class="text-[0.36rem] text-[#888] leading-[0.5rem]">7*24小时在线服务</div>
            </VanCol>
          </VanRow>
        </div>

        {/* 按钮区：默认灰边框 + 激活态绿色填充（act） */}
        <div class="p-[0.56rem]">
          <div class="mb-[0.52rem]">
            <ExternalAnchor
              class="block h-[0.88rem] leading-[0.88rem] rounded-[4px] text-center text-[0.28rem] text-white bg-[#07c160]"
              url={siteConfigStore.customerServiceUrl ?? ''}
              onClick={() => {
                if (!siteConfigStore.customerServiceUrl) showToast('客服暂未配置')
              }}
            >
              <img src={onlineKefu} class="h-[0.32rem] mr-[0.1rem] align-sub inline-block" alt="" />在线客服
            </ExternalAnchor>
          </div>
        </div>
      </div>
    )
  },
})
